import { Text } from "@/components/ui/baseUi/text"
import type { MediaItemFormType } from "@/modules/common/media/mediaFormTypes"
import { cn } from "@/modules/lib/utils"
import { type MediaBlockItemFormikType } from "@/modules/sessions/sessionForm/blocks/mediaBlock/mediaBlockFormikTypes"
import { VideoPlayer } from "@modules/common/media/components/videoPlayer"
import { word } from "@modules/core/utils/i18n"

type MediaExistingBlockVideoProps = {
  media: MediaBlockItemFormikType | MediaItemFormType
  className?: string
} & React.ComponentProps<"div">

export function MediaExistingBlockVideo({ media, className, ...props }: MediaExistingBlockVideoProps) {
  const source = media.file
    ? {
        src: URL.createObjectURL(media.file),
        type: media.file.type === "video/quicktime" ? "video/mp4" : media.file.type,
      }
    : {
        src: media.url,
        type: "application/x-mpegURL",
      }

  return (
    <div className={cn("flex flex-row items-center gap-3 overflow-hidden", className)} {...props}>
      {media.url || media.file ? (
        <VideoPlayer
          options={{
            autoplay: false,
            controls: true,
            experimentalSvgIcons: true,
            sources: [source],
          }}
          size="extrasmall"
          className="min-w-min overflow-hidden rounded-4xl"
        />
      ) : (
        <Text fontStyle="BM" className="wrap-break-word">
          {word("sessionForm.blocks.add_media.missing_error")}
        </Text>
      )}
      <Text fontStyle="BM" className="overflow-hidden overflow-ellipsis">
        {media.filename}
      </Text>
    </div>
  )
}
